import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private logger: NGXLogger) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Verifica se la richiesta è diretta all'API dell'applicazione
    if (request.url.startsWith(environment.apiUrl)) {
      const token = this.authService.getToken();
      //this.logger.info("[AUTH INTERCEPTOR] Token: " + token);
      // Se il token esiste, lo aggiungiamo come header Authorization
      if (token) {
        const authReq = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
        return next.handle(authReq);
      }
    }

    // Se non è necessario aggiungere il token, passa la richiesta originale
    return next.handle(request);
  }
}
